import '../styles/footer.css'

export const Footer = () =>
{
    return <footer className="footer">
        <div className="container p-4">
            <section className="links">
                <div className="row justify-content-center">
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">

                        <ul className="list-unstyled mb-0">
                            <li>
                                <a href="#!" className="text-white">Help</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Advertising</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Jobs</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Conditions of Use</a>
                            </li>
                        </ul>
                    </div>

                    {/* <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase">Links</h5>

                        <ul className="list-unstyled mb-0">
                            <li>
                                <a href="#!" className="text-white">Link 1</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 2</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 3</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 4</a>
                            </li>
                        </ul>
                    </div> */}

                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">

                        <ul className="list-unstyled mb-0">
                            <li>
                                <a href="#!" className="text-white">Site Index</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Privacy Policy</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Interest Based Ads</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Press Room</a>
                            </li>
                        </ul>
                    </div>

                    {/* <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase">Links</h5>

                        <ul className="list-unstyled mb-0">
                            <li>
                                <a href="#!" className="text-white">Link 1</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 2</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 3</a>
                            </li>
                            <li>
                                <a href="#!" className="text-white">Link 4</a>
                            </li>
                        </ul>
                    </div> */}

                </div>
            </section>
        </div>
        <div className="text-center p-3" 
             style={{backgroundColor: '#FF7D63'}}>
            
            <span className="copyright" href="/">© 2022 Copyright: Talented Titles</span>
        </div>
    </footer>
}

